module.exports = __webpack_public_path__ + "media/images/icons/icons_small/48_openedLetter-57781c673e822b7e8af7126efdf04745.png";